import creekWaterAsset from "@/assets/creek-water.jpg.asset.json";

// Soft blurred light-ray streaks rendered as an inline SVG data URL.
const CAUSTICS = `url("data:image/svg+xml,${encodeURIComponent(
  `<svg xmlns='http://www.w3.org/2000/svg' width='900' height='600'>
    <defs>
      <filter id='b' x='-40%' y='-40%' width='180%' height='180%'>
        <feGaussianBlur stdDeviation='26'/>
      </filter>
    </defs>
    <g filter='url(#b)' fill='%23ffffff'>
      <ellipse cx='180' cy='-40' rx='70' ry='420' opacity='0.5' transform='rotate(18 180 300)'/>
      <ellipse cx='460' cy='-60' rx='46' ry='480' opacity='0.38' transform='rotate(12 460 300)'/>
      <ellipse cx='720' cy='-30' rx='90' ry='440' opacity='0.45' transform='rotate(22 720 300)'/>
      <ellipse cx='80' cy='640' rx='60' ry='380' opacity='0.3' transform='rotate(10 80 300)'/>
      <ellipse cx='620' cy='660' rx='55' ry='400' opacity='0.35' transform='rotate(16 620 300)'/>
    </g>
  </svg>`
)}")`;

// Fine water-ripple noise, mimics refracted shimmer across the surface.
const RIPPLE = `url("data:image/svg+xml,${encodeURIComponent(
  `<svg xmlns='http://www.w3.org/2000/svg' width='420' height='420'>
    <filter id='t'>
      <feTurbulence type='fractalNoise' baseFrequency='0.012 0.03' numOctaves='3' seed='7'/>
      <feColorMatrix values='0 0 0 0 0.55  0 0 0 0 0.7  0 0 0 0 0.68  0 0 0 0.9 0'/>
    </filter>
    <rect width='100%' height='100%' filter='url(#t)'/>
  </svg>`
)}")`;

export function CreekWater() {
  return (
    <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden">
      {/* Base: creek bed photo, slow drift */}
      <div
        className="absolute -inset-[6%] bg-cover bg-center will-change-transform motion-safe:animate-[creek-drift_26s_ease-in-out_infinite_alternate]"
        style={{
          backgroundImage: `url(${creekWaterAsset.url})`,
          transform: "translateZ(0)",
        }}
      />

      {/* Teal wash to unify tones with the brand palette */}
      <div
        className="absolute inset-0 mix-blend-multiply"
        style={{
          background:
            "linear-gradient(160deg, #3E6B66 0%, #2E5652 45%, #1F3B38 100%)",
          opacity: 0.55,
          transform: "translateZ(0)",
        }}
      />

      {/* Moving light rays */}
      <div
        className="absolute -inset-[10%] mix-blend-soft-light will-change-transform motion-safe:animate-[creek-rays_14s_ease-in-out_infinite_alternate]"
        style={{
          backgroundImage: CAUSTICS,
          backgroundSize: "cover",
          opacity: 0.9,
          transform: "translateZ(0)",
        }}
      />

      {/* Ripple shimmer */}
      <div
        className="absolute inset-0 mix-blend-overlay will-change-transform motion-safe:animate-[creek-ripple_18s_linear_infinite]"
        style={{
          backgroundImage: RIPPLE,
          backgroundSize: "420px 420px",
          opacity: 0.35,
          transform: "translateZ(0)",
        }}
      />

      {/* Scrim for text readability */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse 90% 80% at 50% 50%, rgba(15,32,30,0.55) 0%, rgba(15,32,30,0.72) 100%)",
          transform: "translateZ(0)",
        }}
      />
    </div>
  );
}
